import { Ref } from "../../../../core/components/Ref";
import { Row } from "../../../../core/components/Row";
import { getNameSocialNetwork } from "../../../../core/constants/utils";
import { FacebookIcon } from "../../../../core/icons/Facebook";
import { InstagramIcon } from "../../../../core/icons/Instagram";
import { TikTokIcon } from "../../../../core/icons/Tiktok";
import { WebIcon } from "../../../../core/icons/Web";

interface SocialMediaLinksProps {
	redesSociales: string[];
}

export const SocialMediaLinks: React.FC<SocialMediaLinksProps> = ({ redesSociales }) => {
	return (
		<Row
			className={`gap-2 md:gap-4 ${redesSociales.length > 2 && "max-md:flex-wrap"}`}
			mainAxisAlignment="center"
			crossAxisAlignment="center"
			flexible
		>
			{redesSociales.map((url, index) => {
				const nameSocialNetwork = getNameSocialNetwork(url);
				const color = nameSocialNetwork === "instagram" ? "instagram" : nameSocialNetwork === "facebook" ? "facebook" : nameSocialNetwork === "tiktok" ? "tiktok" : "default";

				return (
					<Ref
						key={index}
						href={url}
						target="_blank"
						className="max-md:min-w-1/2 w-full self-center font-bold mt-auto"
						size="sm"
						color={color}
						secondary
					>
						<Row
							className="gap-0.5"
							mainAxisAlignment="center"
							crossAxisAlignment="center"
						>
							{nameSocialNetwork === "instagram" ? (
								<InstagramIcon
									className="w-5 h-5 md:w-6 md:h-6"
									stroke="2.5"
								/>
							) : nameSocialNetwork === "facebook" ? (
								<FacebookIcon
									className="w-5 h-5 md:w-6 md:h-6"
									stroke="2.5"
								/>
							) : nameSocialNetwork === "tiktok" ? (
								<TikTokIcon
									className="w-5 h-5 md:w-6 md:h-6"
									stroke="2.5"
								/>
							) : (
								<WebIcon
									className="w-5 h-5 md:w-6 md:h-6"
									stroke="2.5"
								/>
							)}
						</Row>
					</Ref>
				);
			})}
		</Row>
	);
};
